import { Button, ButtonProps } from '@commenda/kakashi';

type TCommendaProductUpsell = {
  heading: string;
  description: string;
  primaryAction?: {
    label: string;
    variant: ButtonProps['variant'];
    disabled?: boolean;
    onClick: () => void;
  };
  caption?: {
    description: string;
    action?: {
      text: string;
      onClick: () => void;
      className?: string;
    };
  };
  imageUrl: string;
};

const CommendaProductUpsellCard = ({
  heading,
  description,
}: {
  heading: string;
  description: string;
}) => {
  return (
    <div className="flex flex-col gap-xs rounded-sm p-xl bg-bg-secondary">
      <h3 className="txt-medium-bold">{heading}</h3>
      <p className="txt-small-regular text-text-secondary">{description}</p>
    </div>
  );
};

const CommendaProductUpsell = ({
  heading,
  description,
  primaryAction,
  caption,
  imageUrl,
}: TCommendaProductUpsell) => {
  return (
    <div className="flex justify-between bg-bg-secondary rounded-sm overflow-clip">
      <div className="p-7xl flex flex-col gap-lg">
        <div className="flex flex-col gap-3xl max-w-[489px]">
          <div className="flex flex-col gap-md">
            <h1 className="display-md-bold">{heading}</h1>
            <p className="txt-extra-large-regular text-text-secondary">
              {description}
            </p>
          </div>
          {primaryAction ? (
            <Button
              size="xl"
              onClick={primaryAction.onClick}
              disabled={!!primaryAction.disabled}
            >
              {primaryAction.label}
            </Button>
          ) : null}
        </div>
        {caption && (
          <div className="flex items-center gap-xs">
            <p className="txt-small-regular text-text-secondary">
              {caption.description}
            </p>
            {caption.action && (
              <Button
                size="sm"
                variant="link"
                onClick={caption.action.onClick}
                className={caption.action.className}
              >
                {caption.action.text}
              </Button>
            )}
          </div>
        )}
      </div>
      <div
        className="w-1/3"
        style={{
          backgroundImage: `url(${imageUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
    </div>
  );
};

export { CommendaProductUpsell, CommendaProductUpsellCard };
